import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import validator from './plugins/validator'
import vuetify from './plugins/vuetify'
import mixin from './mixins/globalMixin'

import Notifications from 'vue-notification'
import VueAxios from 'vue-axios'

import axios from './axios'
import dateUtil from './dateUtil'
import liffUtil from './liffUtil'
import imageUtil from './imageUtil'
import utils from './utils'

import permissionConstant from './constants/permission'

Vue.config.productionTip = false

Vue.use(VueAxios, axios)
Vue.use(Notifications)

const plugin = {
    install (Vue) {
        Vue.prototype.$dateUtil = dateUtil
        Vue.prototype.$liffUtil = liffUtil
        Vue.prototype.$imageUtil = imageUtil
        Vue.prototype.$utils = utils
        Vue.prototype.$validator = validator
        Vue.prototype.$constant = { permission: permissionConstant }
    }
}

Vue.use(plugin)
Vue.mixin(mixin)

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')
